module.exports = __webpack_public_path__ + "img/MS.8b9b7ad2.svg";